import request from '../utils/request'

/**
 * 创建权限
 */
export function createPermission(data) {
  return request({
    url: '/admin/sys-permission',
    method: 'post',
    data
  })
}

/**
 * 更新权限
 */
export function updatePermission(data) {
  return request({
    url: '/admin/sys-permission',
    method: 'put',
    data
  })
}

/**
 * 删除权限
 */
export function deletePermission(id) {
  return request({
    url: `/admin/sys-permission/${id}`,
    method: 'delete'
  })
}

/**
 * 根据ID获取权限
 */
export function getPermissionById(id) {
  return request({
    url: `/admin/sys-permission/${id}`,
    method: 'get'
  })
}

/**
 * 分页查询权限列表
 */
export function getPermissionList(params) {
  return request({
    url: '/admin/sys-permission/list',
    method: 'get',
    params
  })
}

/**
 * 获取所有权限列表
 */
export function getAllPermissions() {
  return request({
    url: '/admin/sys-permission/all',
    method: 'get'
  })
}

